export default __webpack_public_path__ + "static/Kira Kutcher - Age 6-64525f37251d58489c13c88086a61d01.png";